import {Component, OnDestroy, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {ProjectConstants} from '../project-constants';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../models/Offset';
import {GenericArray} from '../../models/GenericArray';
import {DialogDetailComponent} from '../general-components/dialog-detail/dialog-detail.component';
import {UsersService} from './service/users.service';
import {UserModel} from '../../models/UserModel';
import {LoaderService} from '../general-services/service-loader/loader.service';
import { Router } from '@angular/router';
import {BaseGeneralComponent} from '../BaseGeneralComponent';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: UserModel[];
  listData: MatTableDataSource<any>;
  getAllSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  showFilter: boolean;
  filter: any;
  filterContainer: any;
  pageSize: number;
  selectedRowIndex: number;
  isUserSection: boolean;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output() elementSelected = new EventEmitter();

  constructor(private usersService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.sectionId = this.SECTIONS.USER_SETTINGS;
    this.user = JSON.parse(sessionStorage.getItem('user'));
  }

  ngOnInit() {
    this.isUserSection = this.returnIsContractSection(this.router.url);
    this.displayedColumns = ['Username', 'Name', 'Surname', 'Mail', 'Role', 'actions'];
    this.pageSize = 10;
    this.selectedRowIndex = -1;
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.USER_OFFSET);
    this.usersService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.getAll(this.offset);
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    this.getAllSubscribe = this.usersService.getPage(offset, this.filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        }
      );
  }

  openDialog(id: number) {
    const usersData = this.dataSource.find(data => data.id === id) as UserModel;
    let localCustomerListString = '';
    let providerListString = '';
    let regionListString = '';
    let contractTypeListString = '';

    for (let _i = 0; _i < usersData.localCustomerList.length; _i++) {
      const comma = _i === usersData.localCustomerList.length - 1 ? '' : ' ,';
      localCustomerListString += usersData.localCustomerList[_i].description + comma;
    }
    for (let _i = 0; _i < usersData.providerList.length; _i++) {
      const comma = _i === usersData.providerList.length - 1 ? '' : ' ,';
      providerListString += usersData.providerList[_i].description + comma;
    }
    for (let _i = 0; _i < usersData.regionList.length; _i++) {
      const comma = _i === usersData.regionList.length - 1 ? '' : ' ,';
      regionListString += usersData.regionList[_i].description + comma;
    }
    for (let _i = 0; _i < usersData.contractTypeList.length; _i++) {
      const comma = _i === usersData.contractTypeList.length - 1 ? '' : ' ,';
      contractTypeListString += usersData.contractTypeList[_i].description + comma;
    }

    const list: GenericArray[] = [
      {id: 'Username', value: usersData.username.toString()},
      {id: 'Name', value: usersData.name.toString()},
      {id: 'Surname', value: usersData.surname.toString()},
      {id: 'Email', value: usersData.mail.toString()},
      {id: 'Role', value: usersData.roleList[0]},
      {id: 'Associated Local Customer List', value: usersData.localCustomerList.length > 0 ? localCustomerListString : 'N.D.'},
      {id: 'Associated Provider List', value: usersData.providerList.length > 0 ? providerListString : 'N.D.'},
      {id: 'Associated Region List', value: usersData.regionList.length > 0  ? regionListString : 'N.D.'},
      {id: 'Associated Contract Type List', value: usersData.contractTypeList.length > 0 ? contractTypeListString : 'N.D.'}
    ];

    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.USER_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);
  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.usersService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              this.getAll(this.offset);
            } else {
            }
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    this.getAll(this.offset);

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getAllSubscribe) {
      this.getAllSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  /*
  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('userOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('userOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
      this.pageSize = this.offset.pageSize;
    }
  }
  */

}
